import './style.css';
import { closeLibraryModal } from './components/modal';
import { checkForImmersiveVR } from './js/checkForImmersiveVR';
import { loadModelafterLogin } from './components/room1';
import { loadModelafterLoginVR } from './components/vrRoom3';
//import { annotation } from './components/annotation';
const saveButton = document.querySelector(".save-button");

let user = isLoggedIn()
console.log(user)
if(user){
  modalButton.style.display = 'none';
  saveButton.style.display = 'block';
  loadModelafterLogin()
  let details = navigator.userAgent
  let regexp = /android|iphone|kindle|ipad/i;

  let isMobileDevice = regexp.test(details);
  if (isMobileDevice) {
      loadModelafterLogin()
  } else {
      window.navigator.xr.isSessionSupported('immersive-vr').then((supported) => {
          supported ? loadModelafterLoginVR() : loadModelafterLogin()
      })
      .catch((err) => {
          console.log("VR Immersive not supported: " + err);
      });
  }
}
//console.log(isLoggedIn)
document.onkeydown = evt => {
  evt = evt || window.event;
  evt.which === 27 ? closeLibraryModal() : false;
};

function isLoggedIn() {
  let token = window.localStorage.getItem('token');
  console.log(token)
  if (!token) return false
  else return true;
}

//annotation();
checkForImmersiveVR();